import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCalendarPlus, FaRegCalendarAlt } from "react-icons/fa";
import { API_URL } from "../../url/api";
import { formatDateTime, readableDateTime } from "../../utils";
import { CountDown } from "./CountDown";
import { FiCheck, FiClock } from "react-icons/fi";

interface Appointment {
  id: number;
  room_id: string;
  doctor: {
    id: number;
    name: string;
    email: string;
    profile: string;
  };
  schedule_time: {
    id: number;
    date: string;
  };
  time_slot: {
    id: number;
    datetime: string;
  };
  is_paid: boolean;
}

interface User {
  id: number;
  name: string;
  email: string;
  created_at: string;
  appointments: Appointment[];
}

const UpcomingMeetings: React.FC = () => {
  const [appointments, setAppointments] = useState<Appointment[]>([]);

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const response = await axios.get<User>(
          `${API_URL}v2/user/${userId}/upcoming-appointments`
        );
        const data = response.data;

        console.log("app, "+JSON.stringify(data))

        const userAppointments = data.appointments.filter(
          (appointment: Appointment) => appointment.is_paid === true
        );

        const currentTime = new Date();
        const filteredAppointments = userAppointments

        setAppointments(data.appointments.slice(0, 5));
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []);

  return (
    <div className="w-full p-2 mb-4">
      <h2 className="text-2xl font-500 mb-4">Upcoming Meetings</h2>
      <ul className="js grid grid-cols-1 md:grid-cols-2 gap-4">
        {appointments.map((appointment) => {

          // const formattedDate = formatDateTime(
          //   appointment.schedule_time.date,
          //   appointment.time_slot.datetime,
          //   "date"
          // );
          // const formattedTime = formatDateTime(
          //   appointment.schedule_time.date,
          //   appointment.time_slot.datetime,
          //   "time"
          // );

          return (
            <li
              key={appointment.id}
              className="bg-white rounded-lg p-4 flex items-center shadow-sm"
            >
              {/* <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mr-4"> */}
                {
                  appointment.doctor?.profile === null ? (
                    <img
                      src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                      alt="profile"
                      width={"100px"}
                      height={"100px"}
                      className="w-full h-full object-cover rounded-full"
                    />
                  ) : null
                }
                
              {/* </div> */}

              <div className="space-y-2">
                <h3 className="text-lg font-400">{appointment.doctor.name}</h3>

                <div className="flex justify-start items-center space-x-2">
                  <FaRegCalendarAlt size={16} />
                  <p className="font-medium text-sm md:text-md">
                    {readableDateTime(`${appointment.time_slot.datetime}`)}
                  </p>
                </div>
              </div>
              {
                appointment.is_paid ? (
                  <div className="ml-auto bg-green-600 text-white px-3 py-1 rounded-full text-xs flex items-center justify-center gap-1 ">
                    <FiCheck size={20} />
                   Paid
                  </div>
                ) : (
                  <div className="ml-auto bg-orange-400 text-white px-3 py-1 rounded-full text-xs flex items-center justify-center gap-1">
                    
                    <FiClock size={20}  />
                      Payment Pending
                  </div>
                )
              }
              
                {
                  appointment.is_paid && <div className="ml-auto"><CountDown
                  meetingTime={`${appointment.time_slot?.datetime}`}
                  roomId={appointment.room_id}
                />
                </div>
                }
                
            </li>
          );
        })}
      </ul>

      {appointments.length === 0 && (
        <div className="bg-white rounded-lg p-8 text-center border">
          <p>No upcoming meetings</p>
          <button
            className="bg-primary text-white px-4 py-2 rounded-lg mt-4"
            onClick={() =>
              (window.location.href = window.location.href + "/appointments")
            }
          >
            <div className="flex flex-row justify-center items-center space-x-2">
              <FaCalendarPlus size={16} />
              <p>Book a new meeting</p>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default UpcomingMeetings;
